import { useState, useEffect, useCallback } from 'react';

import identityUtils from '../../../utils/identityUtils';

export function useIsMobileOptional() {
  const [isMobileOptional, setIsMobileOptional] = useState(true);
  const user = identityUtils.useLoggedInUserContext();

  const applyUserPermissionsCallback = useCallback(async () => {
    const isCurrentUserInShift = await identityUtils.isCurrentUserInShiftTeam(user);
    setIsMobileOptional(isCurrentUserInShift);
  }, [identityUtils]);

  useEffect(() => {
    applyUserPermissionsCallback();
  }, [applyUserPermissionsCallback]);

  return isMobileOptional;
}
